// client/src/pages/SingleBlog.js

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function getMediaUrl(path) {
  if (!path) return '/assets/images/placeholder.png';
  return `${process.env.REACT_APP_API_URL}/${path}`;
}

export default function SingleBlog() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  // track main preview index
  const [mainIndex, setMainIndex] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/blogs/${id}`)
      .then(res => setBlog(res.data))
      .catch(err => console.error('Error fetching single blog:', err));
  }, [id]);

  if (!blog) {
    return <div className="p-4 mt-16">Loading blog...</div>;
  }

  // combine images + videos
  const media = [...(blog.images || []), ...(blog.videos || [])];
  const mainMedia = media.length > 0 ? getMediaUrl(media[mainIndex]) : null;
  const isVideo = mainMedia && /\.(mp4|mov|avi|webm)$/i.test(mainMedia);

  return (
    <div className="max-w-5xl mx-auto p-4 mt-16">
      <h1 className="text-3xl font-bold mb-4">{blog.title}</h1>

      {/* Main media preview */}
      <div className="border rounded shadow mb-4">
        {mainMedia ? (
          isVideo ? (
            <video
              key={mainIndex}
              src={mainMedia}
              className="w-full h-auto object-contain"
              controls
            />
          ) : (
            <img
              key={mainIndex}
              src={mainMedia}
              alt="blog-media"
              className="w-full h-auto object-contain"
            />
          )
        ) : (
          <img
            src="/assets/images/placeholder.png"
            alt={blog.title}
            className="w-full h-auto object-cover"
          />
        )}
      </div>

      {/* Thumbnails row if multiple media */}
      {media.length > 1 && (
        <div className="flex gap-2 overflow-x-auto mb-6">
          {media.map((m, idx) => {
            const thumbUrl = getMediaUrl(m);
            const thumbIsVideo = /\.(mp4|mov|avi|webm)$/i.test(m);
            return (
              <div
                key={idx}
                className={`border p-1 rounded cursor-pointer hover:shadow 
                            ${idx === mainIndex ? 'ring-2 ring-primaryGreen' : ''}`}
                onClick={() => setMainIndex(idx)}
              >
                {thumbIsVideo ? (
                  <video
                    src={thumbUrl}
                    className="w-16 h-16 object-cover"
                  />
                ) : (
                  <img
                    src={thumbUrl}
                    alt={`blog-thumb-${idx}`}
                    className="w-16 h-16 object-cover"
                  />
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Full blog content */}
      <div
        className="text-gray-700 quill-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
    </div>
  );
}
